// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bb60d03f","513":"2a573423"}[chunkId] + ".chunk.js";
};